<template>
  <div class="art-item art-item2">




    <div class="content">
      <div class="tit">列表关联内容</div>
      <el-radio-group
        class="art-radio-group"
        v-model="radio1"
        @change="changeRadio"
        size="small"
      >
        <el-radio-button label="">
          <span>全部内容</span>
        </el-radio-button>
        <el-radio-button label="1">
          <span>上线内容</span>
        </el-radio-button>
      </el-radio-group>
      <div class="tips">下线的内容仅会展示在体验版</div>
      <div @click="allTy()" class="all-online">
        {{ isall ? "全部下线" : "全部上线" }}
      </div>
      <ul>
        <li v-for="(item, index) in lists" :key="index">
          <div class="item">
            <div class="left">
              <img :src="item.prev_url" alt="内容缩略图" />
            </div>
            <div class="right">
              <div class="title-box">
                <span class="tit tit1">标题：<b v-text="item.title"></b></span>
                <span class="tit tit2"
                  >副标：<b v-text="item.sub_title"></b
                ></span>
                <span class="tit tit3"
                  >跳转：<span>【{{ jump_type[item.jump_type] || "" }}】</span
                  ><b v-text="item.jump_to"></b
                ></span>
              </div>
              <div>
                <span class="tit tit3">上架状态：</span>
                <span @click="showDg(item)">
                  <span class="btn_xtx_01">{{ backTypeshow(item) }}</span>
                  <div v-if="item.start_time">
                    {{ `${item.start_time}——${item.end_time}` }}
                  </div>
                </span>
              </div>
            </div>
          </div>
          <div class="handle">
            <span class="handle-btn" @click="handleFn2(lists, index)"
              >置顶</span
            >
            <span class="handle-btn" @click="handleFn(lists, index, -1)"
              >上移</span
            >
            <span class="handle-btn" @click="handleFn(lists, index, 1)"
              >下移</span
            >
            <span class="handle-btn" @click="delFn(index)">删除</span>
          </div>
        </li>
      </ul>
      <div>
        <el-button size="small" @click="selectFn">选择关联内容</el-button>
      </div>
    </div>
    <div class="foot-btn">
      <el-button size="small" @click="backFn">返回</el-button>
      <el-button size="small" type="primary" @click="saveFn">保存</el-button>
    </div>

    <el-dialog
      title="上线设置"
      class="item3-add-pop"
      :visible.sync="sxdg"
      width="30%"
      :before-close="handleClose"
    >
      <el-radio-group
        class="art-radio-group"
        v-model="forMdat.type"
        size="small"
      >
        <el-radio-button label="0">
          <span>待上架</span>
        </el-radio-button>
        <el-radio-button label="1">
          <span>永久上架</span>
        </el-radio-button>
        <el-radio-button label="2">
          <span>上架时间段</span>
        </el-radio-button>
        <el-radio-button label="-1">
          <span>下架</span>
        </el-radio-button>
      </el-radio-group>
      <el-date-picker
        v-show="forMdat.type == 2"
        v-model="forMdat.times"
        type="datetimerange"
        value-format="yyyy-MM-dd HH:mm:ss"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        placeholder="请选择上线时间段；超过时间段将自动下线"
      >
      </el-date-picker>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="sxdg = false">关 闭</el-button>
        <el-button size="small" type="primary" @click="onlineConfirm()"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <component @sucss="savePopFn" :config="tnconfig" @close="close" v-bind:is="componentName"></component>
  </div>
</template>

<script>
import addWz from "../item3/addWz.vue";
export default {
  components:{
    addWz
  },
  computed: {
    isall() {
      return this.lists.length > 0 && !this.lists.find((e) => e.status == 0);
    },
  },
  data() {
    // 这里存放数据
    return {
       
      tnconfig:{},
      componentName:'',
      jump_type: {
        1: "专题列表",
        2: "大图",
        3: "视频",
        4: "文章",
        5: "链接",
      },
      tmpList: [
        {
          img: "http://static.zookingsoft.com/shiquaner-admin/pc/s11.png",
          title: "正方形卡片列表",
        },
        {
          img: "http://static.zookingsoft.com/shiquaner-admin/pc/s12.png",
          title: "1+3卡片列表",
        },
        {
          img: "http://static.zookingsoft.com/shiquaner-admin/pc/s13.png",
          title: "竖长方形卡片列表",
        },
        {
          img: "http://static.zookingsoft.com/shiquaner-admin/pc/s14.png",
          title: "横长卡片列表",
        },
      ],
      drawer: false,
      dialogVisible: false,
      commonTopData: {
        commonleftbtn: [],
      },
      radio1: "",
      lists: [],
      item: "",
      form: {
        id: "",
        title: "",
        author: "",
        tags: "",
      },
      filterForm1: [
        { prop: "id", label: "内容ID", pl: "请输入内容ID检索" },
        { prop: "title", label: "内容标题", pl: "请输入文章标题检索" },
        { prop: "author", label: "创作者昵称", pl: "请输入创作者检索" },
        { prop: "tags", label: "标签", pl: "请输入标签检索" },
      ],
      selectedData: 0, // 已选择项目
      // timer: null,
      tableData: [],
      total: "",
      typeMap: {
        "-1": "下架",
        0: "待上架",
        1: "上架",
        2: "待上架", //临时上架
      },
      statusMap: {
        "-1": "下架",
        0: "待上架",
        1: "上架",
      },
      showData: {},
      forMdat: {},
      sxdg: false,
    };
  },
  mounted() {
    this.getData("");
  },
  // 方法集合
  methods: {
    onlineConfirm() {
      if (this.forMdat.type == 2) {
        if (!this.forMdat.times || !this.forMdat.times[0]) {
          this.$message("请选择上架时间段");
          return;
        }
        this.showData.start_time = this.forMdat.times[0];
        this.showData.end_time = this.forMdat.times[1];
      } else {
        this.showData.start_time = "";
        this.showData.end_time = "";
      }
      this.showData.type = this.forMdat.type;
      this.sxdg = false;
      this.showData = {};
      this.forMdat = {};
    },
    backTypeshow(da) {
      return this.typeMap[da.type] || this.statusMap[da.status];
    },
    showDg(obj) {
      obj.type = obj.type || obj.status || "1";
      this.showData = obj;
      this.forMdat = Object.assign({}, obj);
      this.sxdg = true;
    },
    backTag(da) {
      let arr = [];
      try {
        arr = JSON.parse(da.tags);
      } catch (error) {
        console.log(error);
      }
      let str = "";
      arr.map((e) => {
        str += `<span>${e}</span>`;
      });
      return str;
    },
    showJump(da) {
      if (da.jump_type == 2) {
        return `<img class="tableImg" src="${da.jump_to}">`;
      }
      if (da.jump_type == 3) {
        return `<video class="tableImg" src="${da.jump_to}"></video>`;
      }
      return da.jump_to;
    },
    allTy() {
      let str = 1;
      if (this.isall) {
        str = 0;
      }
      return this.lists.map((e) => {
        e.status = str;
        return e;
      });
    },
    getData(v) {
      let data = {
        status: v,
      };
      this.api.getArtList(data).then((res) => {
        if (!res) return;
        let { data } = res;

        this.lists = data;
      });
    },
    handleFn2(arr, on) {
      if (on == 0) {
        return;
      }

      let po = arr[on];
      arr.splice(on, 1);
      arr.unshift(po);
    },
    handleFn(arr, index, on) {
      let ond = index + on;
      if (ond >= arr.length) {
        this.$message.warning("到底了");
        return;
      }
      if (ond < 0) {
        this.$message.warning("已经是第一个了");
        return;
      }
      if (on == -1) {
        this.lists.splice(index - 1, 2, arr[index], arr[index - 1]);
      }
      if (on == 1) {
        this.lists.splice(index, 2, arr[index + 1], arr[index]);
      }
    },
    changeRadio(e) {
      this.getData(e);
    },
    delFn(index) {
      this.lists.splice(index, 1);
    },
    selectFn() {
      this.componentName = 'addWz';
      this.tnconfig = {
        pr:{status:'0,1'}
      }

    },
    saveFn() {
      let list = this.lists.map((item) => {
        let obj = {
          id: item.bind_id || item.id,
          type: item.type || item.status || "1",
        };
        if (item.type == 2) {
          obj.start_time = item.start_time;
          obj.end_time = item.end_time;
        }
        return obj;
      });
      let data = {
        relation_content: JSON.stringify(list),
      };
      this.api.getDiscoverArt(data).then((res) => {
        if (!res) return;
        this.$message.success("保存成功");
      });
    },
    close(){
      this.componentName = '';
    },
    savePopFn (da) {
      let arr = da.map(e=>{
        e.type = '0';
        return e;
      })

      this.lists = this.lists.concat(arr)
			this.close();
		},
    backFn() {
      this.$router.push('/art/item-channel')
    },
    handleClose(done) {
      done();
    },

    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    // 全选事件
    handleSelectionChange(val) {
      this.selectedData = val;
    },
    lookBtn() {
      this.$message("look");
    },
  },
};
</script>
<style lang="scss">
.boxdop .el-dialog__footer {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background: #fff;
}
.boxdop .el-dialog__body {
  padding-bottom: 70px !important;
}
</style>
<style lang='scss' scoped>
.art-item2 {
  .top-title {
    padding-left: 100px;
    .tit {
      margin-right: 10px;
    }
    .ipt {
    }
  }
  .content {
    position: relative;
    margin-top: 30px;
    padding-left: 100px;
    background-color: #f5f7fa;
    .art-radio-group {
      display: inline-block;
      margin: 0 20px;
    }
    .tit {
      display: inline;
    }
    .tips {
      display: inline;
      color: #828282;
    }
    .all-online {
      width: 520px;
      margin: 20px 0 10px;
      text-align: right;
      cursor: pointer;
      color: #33b3ff;
    }
    ul {
      li {
        display: flex;
        margin-bottom: 20px;
        .item {
          position: relative;
          display: flex;
          width: 500px;
          padding: 10px;
          border: 1px solid #999;
          border-radius: 4px;
          .left {
            img {
              width: 120px;
              height: 120px;
              border-radius: 4px;
              overflow: hidden;
            }
          }
          .right {
            flex: 1;
            margin-left: 15px;
            .title-box {
              min-height: 100px;
              .tit {
                display: block;
                margin-bottom: 6px;
              }
              b {
                font-weight: normal;
              }
            }
            .art-radio-group {
              position: absolute;
              right: 0;
              bottom: 10px;
              z-index: 9;
              color: #33b3ff;
            }
          }
        }
        .handle {
          margin-left: 10px;
          .handle-btn {
            margin-right: 20px;
            cursor: pointer;
          }
        }
      }
    }
  }
  .foot-btn {
    padding: 20px 0 30px;
    background-color: #f5f7fa;
    text-align: center;
  }
}
</style>

<style lang="scss">
.tableImg {
  display: inline-block;
  max-height: 80px;
  max-width: 200px;
}
.tags_d > span {
  display: inline-block;
  vertical-align: top;
  padding: 2px 5px;

  margin: 2px;
  font-size: 12px;
  border-radius: 5px;
  color: #fff;
  background-color: whitesmoke;

  color: #979797;
  border: 1px solid #eaeaea;
}
.item3-add-pop {
  /deep/.el-dialog {
    position: absolute;
    top: 50%;
    left: 50%;
    z-index: 9;
    transform: translate(-50%, -50%);
    width: 60%;
    min-height: 50vh !important;
  }
  ul {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 30px;
    li {
      margin-right: 30px;
      padding: 12px 16px 16px;
      cursor: pointer;
      border: 1px solid #d9d9d9;
      border-radius: 5px;
      &:last-child {
        margin-right: 0;
      }
      &.on {
        background: #ffffff;
        border: 2px solid #33b3ff;
        box-sizing: border-box;
        box-shadow: 0px 8px 24px rgba(51, 179, 255, 0.2);
        border-radius: 5px;
      }
      .title {
        display: block;
        margin-bottom: 8px;
        color: #000;
      }
      img {
        width: 100%;
      }
    }
  }
  .dialog-footer {
    text-align: center;
  }
}
.btn_xtx_01 {
  color: #33b3ff;
  cursor: pointer;
  text-decoration: underline;
}
</style>
